module.exports = __webpack_public_path__ + "img/attachment.e81c184f.svg";